import React, { createContext, useContext, ReactNode } from "react";
import { SharedPostFlowHook, SharedPostFlowProps, useSharedPostFlow } from "./hooks/useSharedPostFlow";

interface SharedPostFlowContextType extends SharedPostFlowHook {}

const PostFlowContext = createContext<SharedPostFlowContextType | undefined>(undefined);

export function usePostFlowContext() {
  const context = useContext(PostFlowContext);
  if (!context) {
    throw new Error("usePostFlowContext must be used within a SharedPostFlowProvider");
  }
  return context;
}

interface PostFlowProviderProps extends SharedPostFlowProps {
  children: ReactNode;
}

export function PostFlowProvider({ children, defaults }: PostFlowProviderProps) {
  const context = useSharedPostFlow({ defaults });
  return <PostFlowContext.Provider value={context}>{children}</PostFlowContext.Provider>;
}
